/* Cupom Ethos — copiar código + contagem regressiva + auto-expiração.
   Reexecuta em re-render do drawer do carrinho, então tudo é idempotente. */
(function () {
  'use strict';

  var COPY_RESET_MS = 2000;

  function copyToClipboard(text) {
    // Clipboard API só existe em contexto seguro; o fallback cobre o resto.
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  function selectCode(root) {
    // Sem permissão de clipboard: ao menos deixa o código selecionado
    // para o cliente copiar na mão.
    var codeEl = root.querySelector('[data-coupon-code]');
    if (!codeEl || !window.getSelection) return;
    var range = document.createRange();
    range.selectNodeContents(codeEl);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  function bindCopy(root) {
    var btn = root.querySelector('[data-coupon-copy]');
    if (!btn || btn.dataset.ecBound === '1') return;
    btn.dataset.ecBound = '1';

    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-code') || '';
      var labelCopy = btn.getAttribute('data-label-copy') || 'Copiar';
      var labelCopied = btn.getAttribute('data-label-copied') || 'Copiado!';
      var status = root.querySelector('[data-coupon-status]');

      copyToClipboard(code).then(function () {
        btn.textContent = labelCopied;
        btn.classList.add('is-copied');
        if (status) status.textContent = 'Cupom ' + code + ' copiado.';
        window.clearTimeout(btn._ecTimer);
        btn._ecTimer = window.setTimeout(function () {
          btn.textContent = labelCopy;
          btn.classList.remove('is-copied');
        }, COPY_RESET_MS);
      }).catch(function () {
        selectCode(root);
        if (status) status.textContent = 'Selecione e copie o cupom ' + code + '.';
      });
    });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function formatRemaining(sec) {
    var d = Math.floor(sec / 86400);
    var h = Math.floor((sec % 86400) / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    if (d > 0) return d + (d === 1 ? ' dia ' : ' dias ') + pad(h) + 'h' + pad(m) + 'm';
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function bindTimer(root) {
    var expires = parseInt(root.getAttribute('data-expires') || '0', 10);
    if (!expires) return;

    var timer = root.querySelector('[data-coupon-timer]');
    var textEl = root.querySelector('[data-coupon-timer-text]');

    function tick() {
      var remaining = expires - Math.floor(Date.now() / 1000);

      if (remaining <= 0) {
        // Expirou com a página aberta: some da tela sem precisar recarregar.
        root.hidden = true;
        root.style.display = 'none';
        window.clearInterval(root._ecInterval);
        return;
      }
      if (timer && textEl) {
        textEl.textContent = 'Termina em ' + formatRemaining(remaining);
        timer.hidden = false;
      }
    }

    window.clearInterval(root._ecInterval);
    tick();
    if (!root.hidden) root._ecInterval = window.setInterval(tick, 1000);
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ethos-coupon]');
    for (var i = 0; i < nodes.length; i++) {
      bindCopy(nodes[i]);
      bindTimer(nodes[i]);
    }
  }

  window.EthosCoupon = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // O drawer do carrinho troca o HTML inteiro ao atualizar; sem isso o
  // botão de copiar vira decoração depois da primeira alteração.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-ethos-coupon]')) return;
    window.setTimeout(function () { init(); }, 350);
  }, true);
})();
